import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Zap, Flame, Shield, Leaf, Star, Crown, Heart, ArrowRight, Check, ChevronDown } from 'lucide-react';
import { products, features, testimonials, faqs } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const BANNER_URL =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/ed780c5f9885f6f1_Aura%20King%20y%20Queen_%20Lujo%20Natural.png';
const LOGO_URL =
  'https://customer-assets-rejwkqb3.emergentagent.net/job_6105b58a-7e55-474e-a974-617e58e42c4a/artifacts/q23o4nye_Gemini_Generated_Image_487caf487caf487c.png';
const SACHETS_URL =
  'https://customer-assets-rejwkqb3.emergentagent.net/job_6105b58a-7e55-474e-a974-617e58e42c4a/artifacts/t1z9tgqy_ecbe1034-e773-4558-b644-a8b3fac009a4.png';
const USAGE_POSTER_URL =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/4a77f9ea3e3d62a1_ChatGPT%20Image%2025%20ago%202026%2C%2005_23_25%20p.m..png';
const KING_SACHET_URL =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/p5e4fm1f_1.png';
const QUEEN_SACHET_URL =
  'https://customer-assets-39nsmqrw.emergentagent.net/job_chocolate-supreme-mx/artifacts/nb3ap3ix_2.png';

const GOLD = '#C9A84C';
const iconMap = { Zap, Flame, Shield, Leaf, Star, Crown, Heart };

export default function Home() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setActiveTestimonial((p) => (p + 1) % testimonials.length),
      5000
    );
    return () => clearInterval(t);
  }, []);

  return (
    <main style={{ background: '#0A0A0A', color: '#fff', fontFamily: 'Montserrat, sans-serif' }}>
      {/* ===== HERO ===== */}
      <section
        style={{
          position: 'relative',
          minHeight: '100vh',
          backgroundImage: `url(${BANNER_URL})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          alignItems: 'flex-end',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            maxWidth: '80rem',
            margin: '0 auto',
            padding: '0 1.5rem 4rem',
            width: '100%',
          }}
        >
          <div style={{ maxWidth: '22rem', animation: 'fadeInUp 0.9s ease-out' }}>
            <h1
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(2rem, 3.5vw, 3rem)',
                fontWeight: 300,
                lineHeight: 1.15,
                color: '#fff',
                marginBottom: '1.25rem',
                textShadow: '0 2px 12px rgba(0,0,0,0.8)',
              }}
            >
              Despierta tu{' '}
              <span style={{ color: GOLD, fontStyle: 'italic' }}>Aura</span>
            </h1>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.85rem' }}>
              <a
                href="#productos"
                style={{
                  padding: '0.85rem 1.75rem',
                  background: GOLD,
                  color: '#000',
                  fontSize: '0.68rem',
                  letterSpacing: '0.25em',
                  textTransform: 'uppercase',
                  fontWeight: 700,
                  textDecoration: 'none',
                  transition: 'opacity 0.3s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.85')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                Comprar Ahora
              </a>
              <Link
                to="/caracteristicas"
                style={{
                  padding: '0.5rem 1rem',
                  border: '1px solid rgba(201,168,76,0.5)',
                  color: GOLD,
                  fontSize: '0.6rem',
                  letterSpacing: '0.2em',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  transition: 'background 0.3s ease',
                  backdropFilter: 'blur(4px)',
                  background: 'rgba(0,0,0,0.3)',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(201,168,76,0.12)')}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(0,0,0,0.3)')}
              >
                Ver Características
              </Link>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div
          className="animate-bounce"
          style={{
            position: 'absolute',
            bottom: '2rem',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          <ChevronDown size={20} style={{ color: 'rgba(201,168,76,0.5)' }} />
        </div>
      </section>

      {/* ===== STATS BAR ===== */}
      <div
        style={{
          background: '#070707',
          borderTop: '1px solid rgba(201,168,76,0.12)',
          borderBottom: '1px solid rgba(201,168,76,0.12)',
        }}
      >
        <div
          style={{
            maxWidth: '80rem',
            margin: '0 auto',
            padding: '1.5rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
          }}
        >
          {[['12', 'Sachets por Bolsa'], ['20g', 'Por Sachet'], ['Natural', 'de Alta Calidad']].map(([val, lab], i) => (
            <div
              key={i}
              style={{
                textAlign: 'center',
                padding: '0 1rem',
                borderRight: i < 2 ? '1px solid rgba(201,168,76,0.12)' : 'none',
              }}
            >
              <div
                style={{
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: '2rem',
                  fontWeight: 300,
                  color: GOLD,
                  marginBottom: '0.25rem',
                }}
              >
                {val}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase' }}>
                {lab}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ===== ABOUT ===== */}
      <section style={{ padding: '6rem 1.5rem' }}>
        <div
          style={{
            maxWidth: '80rem',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '4rem',
            alignItems: 'center',
          }}
          className="lg:grid-cols-2"
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ position: 'relative' }}>
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: `radial-gradient(circle, ${GOLD}, transparent)`,
                  opacity: 0.12,
                  filter: 'blur(48px)',
                  borderRadius: '50%',
                  transform: 'scale(0.8)',
                  pointerEvents: 'none',
                }}
              />
              <img
                src={USAGE_POSTER_URL}
                alt="¿Cómo se utiliza Aura?"
                style={{ position: 'relative', width: '100%', maxWidth: '22rem', objectFit: 'contain', borderRadius: '2px' }}
              />
            </div>
          </div>
          <div>
            <p style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '1rem' }}>
              Sobre el Producto
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(2.2rem, 4vw, 3.5rem)',
                fontWeight: 300,
                lineHeight: 1.15,
                color: '#fff',
                marginBottom: '1.5rem',
              }}
            >
              La Fórmula{' '}
              <span style={{ color: GOLD, fontStyle: 'italic' }}>Supreme</span>
            </h2>
            <p style={{ fontSize: '0.85rem', lineHeight: 1.85, color: 'rgba(255,255,255,0.55)', marginBottom: '2rem' }}>
              Aura King &amp; Queen nace de la pasión por crear una experiencia sensorial única. Nuestro chocolate
              afrodisíaco combina los más finos ingredientes naturales con una fórmula exclusiva para elevar tu
              vitalidad al máximo nivel.
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 2rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              {[
                'Ingredientes Naturales de Alta Calidad',
                'Sin conservadores artificiales',
                'Fórmula Afrodisíaca Funcional',
                'Chocolate de cacao premium',
                'Exclusivo para adultos +18',
              ].map((item, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <Check size={13} style={{ color: GOLD, flexShrink: 0 }} />
                  <span style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)' }}>{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/caracteristicas"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: GOLD,
                fontSize: '0.78rem',
                letterSpacing: '0.1em',
                textDecoration: 'none',
                transition: 'opacity 0.3s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.7')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
              Ver todas las características <ArrowRight size={13} />
            </Link>
          </div>
        </div>
      </section>

      {/* ===== FEATURE GRID ===== */}
      <section style={{ padding: '5rem 1.5rem', background: '#060606' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
            <p style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
              Beneficios
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(2rem, 3.5vw, 2.8rem)',
                fontWeight: 300,
                color: '#fff',
              }}
            >
              Diseñado para tu{' '}
              <span style={{ color: GOLD, fontStyle: 'italic' }}>Bienestar</span>
            </h2>
          </div>
          <div
            className="grid grid-cols-2 lg:grid-cols-4"
            style={{ gap: '1.25rem' }}
          >
            {features.slice(0, 4).map((f) => {
              const Icon = iconMap[f.icon] || Star;
              return (
                <div
                  key={f.id}
                  style={{
                    background: '#111111',
                    border: '1px solid rgba(201,168,76,0.1)',
                    padding: '2rem',
                    textAlign: 'center',
                    cursor: 'default',
                    transition: 'border-color 0.3s ease, transform 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(201,168,76,0.45)';
                    e.currentTarget.style.transform = 'translateY(-4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(201,168,76,0.1)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <div
                    style={{
                      display: 'inline-flex',
                      width: '3rem',
                      height: '3rem',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      background: 'rgba(201,168,76,0.08)',
                      marginBottom: '1.25rem',
                    }}
                  >
                    <Icon size={20} style={{ color: GOLD }} />
                  </div>
                  <h3 style={{ color: '#fff', fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.6rem' }}>{f.title}</h3>
                  <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.75rem', lineHeight: 1.7 }}>
                    {f.description.slice(0, 80)}…
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ===== PRODUCTS ===== */}
      <section id="productos" style={{ padding: '6rem 1.5rem', background: '#070707' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
            <p style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
              Nuestros Productos
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(2rem, 3.5vw, 2.8rem)',
                fontWeight: 300,
                color: '#fff',
                marginBottom: '0.5rem',
              }}
            >
              King <span style={{ color: GOLD }}>&amp;</span> Queen
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.72rem', letterSpacing: '0.15em' }}>
              Dos versiones · Un mismo propósito
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2" style={{ gap: '2.5rem', maxWidth: '56rem', margin: '0 auto' }}>
            {products.map((p) => {
              const sachetImg = p.type === 'king' ? KING_SACHET_URL : QUEEN_SACHET_URL;
              return (
                <div
                  key={p.id}
                  style={{
                    background: '#0d0d0d',
                    border: '1px solid rgba(201,168,76,0.2)',
                    boxShadow: '0 20px 50px rgba(0,0,0,0.6), 0 0 30px rgba(201,168,76,0.05)',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 32px 70px rgba(0,0,0,0.7), 0 0 45px rgba(201,168,76,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.6), 0 0 30px rgba(201,168,76,0.05)';
                  }}
                >
                  {/* Product image area */}
                  <div
                    style={{
                      background: '#080808',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '2.5rem 2rem',
                      minHeight: '280px',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'radial-gradient(circle at 50% 80%, rgba(201,168,76,0.07) 0%, transparent 60%)',
                        pointerEvents: 'none',
                      }}
                    />
                    <img
                      src={sachetImg}
                      alt={p.name}
                      style={{
                        position: 'relative',
                        height: '230px',
                        objectFit: 'contain',
                        filter: 'drop-shadow(0 8px 24px rgba(201,168,76,0.22))',
                        transition: 'transform 0.4s ease',
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                      onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                    />
                  </div>

                  {/* Product info */}
                  <div style={{ padding: '1.75rem' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
                      <div>
                        <span
                          style={{
                            display: 'inline-block',
                            padding: '0.2rem 0.75rem',
                            border: '1px solid rgba(201,168,76,0.3)',
                            background: 'rgba(201,168,76,0.07)',
                            color: GOLD,
                            fontSize: '0.6rem',
                            letterSpacing: '0.2em',
                            textTransform: 'uppercase',
                            marginBottom: '0.6rem',
                          }}
                        >
                          {p.badge}
                        </span>
                        <h3
                          style={{
                            fontFamily: 'Cormorant Garamond, serif',
                            fontSize: '1.8rem',
                            fontWeight: 300,
                            color: '#fff',
                          }}
                        >
                          {p.name}
                        </h3>
                      </div>
                      <div style={{ display: 'flex', gap: '1px', paddingTop: '0.25rem' }}>
                        {Array(5).fill(0).map((_, i) => (
                          <Star key={i} size={11} fill={GOLD} style={{ color: GOLD }} />
                        ))}
                      </div>
                    </div>

                    <p style={{ color: GOLD, fontStyle: 'italic', fontSize: '0.78rem', marginBottom: '0.6rem' }}>{p.tagline}</p>
                    <p style={{ fontSize: '0.78rem', lineHeight: 1.75, color: 'rgba(255,255,255,0.5)', marginBottom: '1.25rem' }}>
                      {p.description}
                    </p>

                    <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                      {p.benefits.slice(0, 4).map((b, i) => (
                        <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)' }}>
                          <Check size={10} style={{ color: GOLD }} />{b}
                        </li>
                      ))}
                    </ul>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingTop: '1.25rem',
                        borderTop: '1px solid rgba(201,168,76,0.12)',
                      }}
                    >
                      <div>
                        <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '2rem', fontWeight: 300, color: GOLD, lineHeight: 1 }}>
                          $120 <span style={{ fontSize: '1rem' }}>MXN</span>
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.62rem', letterSpacing: '0.08em', marginTop: '0.1rem' }}>
                          por sachet
                        </div>
                      </div>
                      <Link
                        to="/distribuidores"
                        style={{
                          padding: '0.8rem 1.5rem',
                          background: GOLD,
                          color: '#000',
                          fontSize: '0.65rem',
                          letterSpacing: '0.15em',
                          textTransform: 'uppercase',
                          fontWeight: 700,
                          textDecoration: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          transition: 'opacity 0.3s ease',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.82')}
                        onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
                      >
                        ¿Dónde Comprar?
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>


      {/* ===== FAQ ===== */}
      <section style={{ padding: '6rem 1.5rem' }}>
        <div style={{ maxWidth: '48rem', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
            <p style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
              Información
            </p>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: 'clamp(2rem, 3.5vw, 2.8rem)',
                fontWeight: 300,
                color: '#fff',
              }}
            >
              Preguntas{' '}
              <span style={{ color: GOLD, fontStyle: 'italic' }}>Frecuentes</span>
            </h2>
          </div>

          <Accordion type="single" collapsible style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                className="border-none"
                style={{
                  background: '#111111',
                  border: '1px solid rgba(201,168,76,0.15)',
                  borderRadius: 0,
                  color: '#fff',
                  overflow: 'hidden',
                }}
              >
                <AccordionTrigger
                  className="hover:no-underline px-6 py-5 text-left"
                  style={{
                    color: '#fff',
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '0.82rem',
                    fontWeight: 500,
                  }}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent
                  className="px-6 pb-5"
                  style={{
                    color: 'rgba(255,255,255,0.55)',
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '0.8rem',
                    lineHeight: 1.8,
                  }}
                >
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* ===== CTA BANNER ===== */}
      <section
        style={{
          padding: '5rem 1.5rem',
          textAlign: 'center',
          background: '#060606',
          borderTop: '1px solid rgba(201,168,76,0.1)',
        }}
      >
        <div style={{ maxWidth: '36rem', margin: '0 auto' }}>
          <p style={{ color: GOLD, fontSize: '0.68rem', letterSpacing: '0.4em', textTransform: 'uppercase', marginBottom: '1rem' }}>
            Empieza Hoy
          </p>
          <h2
            style={{
              fontFamily: 'Cormorant Garamond, serif',
              fontSize: 'clamp(2.2rem, 4vw, 3.5rem)',
              fontWeight: 300,
              color: '#fff',
              marginBottom: '1rem',
            }}
          >
            Comienza tu{' '}
            <span style={{ color: GOLD, fontStyle: 'italic' }}>Experiencia</span>
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.38)', fontSize: '0.8rem', marginBottom: '2.5rem' }}>
            Envíos a toda la República Mexicana · 12 sachets por bolsa
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem' }}>
            <a
              href="#productos"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '1.1rem 2.5rem',
                background: GOLD,
                color: '#000',
                fontSize: '0.72rem',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                fontWeight: 700,
                textDecoration: 'none',
                transition: 'opacity 0.3s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.85')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
              <Crown size={15} />
              Ver Productos
            </a>
            <Link
              to="/distribuidores"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.6rem',
                padding: '1.1rem 2.5rem',
                border: '1px solid rgba(201,168,76,0.35)',
                color: GOLD,
                fontSize: '0.72rem',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                textDecoration: 'none',
                transition: 'background 0.3s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(201,168,76,0.06)')}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
              Distribuidores
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
